import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Container, Description, Overlay, Tag } from "./styles";

const TokenExpirationChecker = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState(sessionStorage.getItem("access_token"));

  useEffect(() => {
    const checkToken = () => {
      setToken(sessionStorage.getItem("access_token"));
    };

    const interval = setInterval(checkToken, 1000); // 1초마다 체크
    checkToken();

    return () => clearInterval(interval);
  }, []);

  const isLoginRoute = /^\/login\/?$/.test(location.pathname);

  if (token || isLoginRoute) return null;

  return (
    <Overlay>
      <Container>
        <Tag>Your session has expired!</Tag>
        <Description>
          You have been signed out of your account. In order to re-sign in
          again, click on the following button.
        </Description>
        <Button onClick={() => navigate("/login")}>Get back to login</Button>
      </Container>
    </Overlay>
  );
};

export default TokenExpirationChecker;
